import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-de532af2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "botton-box"
};
const _hoisted_2 = /*#__PURE__*/ _createTextVNode("取消");
const _hoisted_3 = /*#__PURE__*/ _createTextVNode("保存");
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" 确认 ");
import { ref, reactive } from "vue";
import PasswordCheck from "@/components/PasswordCheck/index.vue";
import CloudButton from "@/components/CloudButton/index.vue";
import { modifySubPassword } from "@/service/login";
import { checkPassword, useBcrypt } from "@/utils";
import { ElForm } from "element-plus";
export default /*#__PURE__*/ _defineComponent({
    name: 'SubChange',
    props: {
        isCancel: { type: Boolean }
    },
    emits: ["success", "cancel"],
    setup(__props, { expose, emit }) {
        const resetForm = ref(null);
        const password = ref("");
        const passwordVerify = ref("");
        const passwordShow = ref(false);
        const passwordVerifyShow = ref(false);
        const resetData = reactive({
            oldPassword: "",
            password: "",
            passwordVerify: ""
        });
        const checkSame = (rule, value, callback) => {
            if (value !== resetData.password) {
                callback(new Error("两次输入密码不一致!"));
            }
            else {
                callback();
            }
        };
        const resetRules = reactive({
            oldPassword: [
                { required: true, message: "请输入旧密码~", triiger: "blur" }
            ],
            password: [
                { required: true, message: "请输入密码~", triiger: "blur" },
                { validator: checkPassword, trigger: "blur" }
            ],
            passwordVerify: [
                { required: true, message: "请再次输入密码~", triiger: "blur" },
                { validator: checkSame, trigger: "blur" },
                { validator: checkPassword, trigger: "blur" }
            ]
        });
        const submit = () => {
            resetForm.value?.validate((valid) => {
                if (valid) {
                    let params = {
                        old_password: useBcrypt(resetData.oldPassword),
                        new_password: useBcrypt(resetData.passwordVerify)
                    };
                    modifySubPassword(params).then(() => {
                        emit("success");
                    });
                }
            });
        };
        const focusHandle = (value) => {
            if (value === "password") {
                passwordShow.value = true;
            }
            else {
                passwordVerifyShow.value = true;
            }
        };
        const blurHandle = (value) => {
            if (value === "password") {
                passwordShow.value = false;
            }
            else {
                passwordVerifyShow.value = false;
            }
        };
        const changeHandle = (value) => {
            if (value === "password") {
                password.value = resetData.password;
            }
            else {
                passwordVerify.value = resetData.passwordVerify;
            }
        };
        const cancelHandle = () => {
            emit("cancel");
        };
        expose({
            submit
        });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(ElForm), {
                    ref_key: "resetForm",
                    ref: resetForm,
                    model: resetData,
                    rules: resetRules,
                    size: "large"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "oldPassword" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    key: "oldPassword",
                                    modelValue: resetData.oldPassword,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((resetData.oldPassword) = $event)),
                                    placeholder: "旧密码",
                                    "show-password": ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "password" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    key: "password",
                                    modelValue: resetData.password,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((resetData.password) = $event)),
                                    placeholder: "新密码",
                                    "show-password": "",
                                    onFocus: _cache[2] || (_cache[2] = ($event) => (focusHandle('password'))),
                                    onBlur: _cache[3] || (_cache[3] = ($event) => (blurHandle('password'))),
                                    onInput: _cache[4] || (_cache[4] = ($event) => (changeHandle('password')))
                                }, null, 8, ["modelValue"]),
                                _withDirectives(_createVNode(PasswordCheck, { value: password.value }, null, 8, ["value"]), [
                                    [_vShow, passwordShow.value]
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "passwordVerify" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                    modelValue: resetData.passwordVerify,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((resetData.passwordVerify) = $event)),
                                    placeholder: "确认新密码",
                                    "show-password": "",
                                    onFocus: _cache[6] || (_cache[6] = ($event) => (focusHandle('passwordVerify'))),
                                    onBlur: _cache[7] || (_cache[7] = ($event) => (blurHandle('passwordVerify'))),
                                    onInput: _cache[8] || (_cache[8] = ($event) => (changeHandle('passwordVerify'))),
                                    onKeydown: _withKeys(submit, ["enter"])
                                }, null, 8, ["modelValue", "onKeydown"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["model", "rules"]),
                (__props.isCancel)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(CloudButton, {
                            size: "large",
                            type: "light",
                            onClick: cancelHandle
                        }, {
                            default: _withCtx(() => [
                                _hoisted_2
                            ]),
                            _: 1
                        }),
                        _createVNode(CloudButton, {
                            type: "deep",
                            size: "large",
                            onClick: submit
                        }, {
                            default: _withCtx(() => [
                                _hoisted_3
                            ]),
                            _: 1
                        })
                    ]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "large",
                        type: "primary",
                        class: "login-btn",
                        onClick: submit
                    }, {
                        default: _withCtx(() => [
                            _hoisted_4
                        ]),
                        _: 1
                    }))
            ]));
        };
    }
});
